import { CopyButton } from "@arcadeai/design-system/components/ui/atoms/copy-button";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  OAUTH_PROVIDER_CATALOGUE,
  OAUTH2_PROVIDER,
} from "@arcadeai/design-system/metadata/oauth-providers";
import { useParams } from "@tanstack/react-router";
import { CardStatusBadge } from "@/components/custom/card-status-badge";
import { useGetOAuthProviders } from "../api/hooks";
import { ConnectedAccounts } from "./connected-accounts/connected-accounts";
import { Tools } from "./tools";

export const Details = () => {
  const { oauthId } = useParams({
    from: "/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId",
  });

  const { data: oauthProviders = [] } = useGetOAuthProviders("project");

  const item = oauthProviders.find((provider) => provider.id === oauthId);

  const descriptor = item?.provider_id
    ? (OAUTH_PROVIDER_CATALOGUE[item.provider_id] ?? OAUTH2_PROVIDER)
    : OAUTH2_PROVIDER;

  const isStatic = item?.binding.type === "static";

  if (!item) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-4">
        <descriptor.icon className="h-8 w-8" />
        <h1 className="font-bold text-2xl">{item.id}</h1>
        <CardStatusBadge
          isEnabled={item.status === "active"}
          isStatic={isStatic}
          showEnabled={true}
        />
      </div>

      {item.oauth2?.redirect_uri ? (
        <div className="space-y-3 rounded-lg border bg-card/50 p-5">
          <div>
            <h3 className="font-medium text-foreground text-sm">
              Redirect URI
            </h3>
            <p className="mt-0.5 text-muted-foreground text-xs">
              Copy and paste this redirect URI into your OAuth application
              settings
            </p>
          </div>
          <div className="relative">
            <Input
              className="pr-10"
              readOnly
              value={item.oauth2.redirect_uri}
            />
            <CopyButton
              className="absolute top-1/2 right-2 h-auto -translate-y-1/2 px-2 py-1"
              content={item.oauth2.redirect_uri}
              variant="ghost"
            />
          </div>
        </div>
      ) : (
        <div className="rounded-lg border bg-card/50 p-5">
          <div>
            <h3 className="font-medium text-foreground text-sm">
              Redirect URI
            </h3>
            <p className="mt-0.5 text-muted-foreground text-xs">
              No redirect URI configured for this OAuth provider
            </p>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 gap-6">
        <ConnectedAccounts oauthProviderId={item.id} />
        <Tools provider_id={item.provider_id} />
      </div>
    </div>
  );
};
